/**
 * Accepts an array of pre-checked providers and returns the providers in a key
 * value pair where the key is providers and the value is a comma separated
 * string of provider names
 *
 * @param {array} preCheckedProviders Pre-checked providers list
 */
export const formatPreCheckedProviders = ({ preCheckedProviders }) => {
  if (preCheckedProviders.length === 0) return { providers: '' }

  const formattedNames = {
    providers: preCheckedProviders
      .map(provider => provider.providerName)
      .filter(name => name) // Filter out undefined, null, or empty strings
      .join(', '),
  }

  return formattedNames
}
